import dayjs from 'dayjs';
import { compare } from 'utils/date';

/**
 * Processes a list of tradeshows and splits them into upcoming and past
 * @param {Array} shows - List of tradeshows to process
 * @return {Object} Object containing upcoming and past tradeshows
 */
export const processTradeShows = shows => {
  if (!shows || shows.length === 0) return { upcoming: [], past: [] };

  // Remove duplicates by ID
  let allTradeshows = shows.reduce((acc, current) => {
    if (!acc.some(x => x.id === current.id)) {
      acc.push(current);
    }
    return acc;
  }, []);

  const currentDate = dayjs();

  const upcomingTradeshows = allTradeshows
    .filter(x => dayjs(x.endDate).isAfter(currentDate))
    .sort((a, b) => compare(a, b));

  const pastTradeshows = allTradeshows
    .filter(
      x =>
        dayjs(x.endDate).isBefore(currentDate) &&
        dayjs(x.endDate).isAfter(currentDate.subtract(2, 'month'))
    )
    .sort((a, b) => compare(b, a));

  return { upcoming: upcomingTradeshows, past: pastTradeshows };
};

/**
 * Extracts tradeshows from activity search results
 * @param {Object} activityResponse - Response from activity search
 * @return {Array} List of extracted tradeshows
 */
export const extractTradeshowsFromActivities = activityResponse => {
  if (!activityResponse?.groupedResults?.length) return [];

  const tradeshowItems = activityResponse.groupedResults.filter(
    item => item.category.toLowerCase() === 'tradeshow'
  );

  if (tradeshowItems.length === 0) return [];

  return tradeshowItems.map(t => ({
    id: t.sciLeadsTradeShowId,
    name: t.show,
    date: t.date,
    endDate: t.endDate,
  }));
};
